import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getBusinessNameWithAdsStyles } from './styles/business-name-with-ads';

export const BusinessNameWithAds = ({
  businessName,
  i18n,
  onlyIcon,
  showLabel,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getBusinessNameWithAdsStyles({ styleOverrides }));

  return (
    <div className={classnames('business-name-with-ads', classes.businessNameWithAds)}>
      {
        showLabel &&
        <span className="adslabel">
          {i18n.getString(_TL_('Ad'))}
        </span>
      }
      { !onlyIcon &&
        <span className="business-name">
          {businessName}
        </span>
      }
    </div>
  );
};

BusinessNameWithAds.propTypes = {
  businessName: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onlyIcon: PropTypes.bool,
  showLabel: PropTypes.bool,
  styleOverrides: PropTypes.shape({}),
};

BusinessNameWithAds.defaultProps = {
  onlyIcon: false,
  showLabel: false,
  styleOverrides: {},
};
